export default {
    data() {
        return {
            defaultImg: require('@/assets/images/hall-default@3x.png'),
            imgOnError: `this.onerror=''; src='${require('@/assets/images/hall-default@3x.png')}'`,
        };
    },
};
